import { Reveal, Eyebrow, MaskedLine } from "../components/Reveal";
import { SITE } from "../data/site";

const SECTIONS = [
  {
    title: "1. Who we are",
    body: `${SITE.name} ("Terra Bloom", "we", "us") is an oil and petrochemicals trading company registered in Dubai, United Arab Emirates. This policy explains how we handle personal data submitted through this website.`,
  },
  {
    title: "2. Data we collect",
    body: "When you submit the inquiry form we collect your name, business email, phone number (with country code), product interest and message content. We also record brochure download events (timestamp only). We do not collect payment data, and we do not use advertising trackers.",
  },
  {
    title: "3. How we use it",
    body: "Inquiry data is used solely to respond to your request, prepare quotations and manage the resulting commercial relationship. We do not sell, rent or share your details with third parties for marketing purposes.",
  },
  {
    title: "4. Storage & security",
    body: "Inquiry records are stored in a secured database with access restricted to our trading and management team. Records are retained for up to 24 months after our last correspondence, unless a contract requires longer retention.",
  },
  {
    title: "5. Spam protection",
    body: "This website may use Google reCAPTCHA to protect the inquiry form from abuse. Where enabled, reCAPTCHA collects hardware and software information in line with Google's Privacy Policy and Terms of Service.",
  },
  {
    title: "6. Your rights",
    body: "You may request a copy, correction or deletion of your personal data at any time by writing to the contact address below. We respond to all verified requests within 30 days.",
  },
  {
    title: "7. Contact",
    body: `Privacy questions and data requests: ${SITE.email} — ${SITE.address}.`,
  },
];

export default function Privacy() {
  return (
    <>
      <section data-testid="privacy-hero" className="bg-[#F5F5F2] pb-14 pt-40 noise-surface">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Eyebrow>Legal</Eyebrow>
          <h1 className="mt-5 font-display text-5xl font-bold uppercase text-[#0E1526] sm:text-7xl">
            <MaskedLine delay={0.15}>Privacy Policy</MaskedLine>
          </h1>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
            Last updated — July 2026
          </p>
        </div>
      </section>
      <section data-testid="privacy-content" className="bg-white py-20">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={0.05} className={i > 0 ? "mt-12" : ""}>
              <h2 className="font-display text-2xl font-semibold uppercase tracking-wide text-amber-600">{s.title}</h2>
              <p className="mt-4 text-base leading-relaxed text-slate-700">{s.body}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
